/* Native email validation needs international domain names in ASCII form. */
(() => {
  'use strict';
  function normalizeEmailDomain(value) {
    const email = value.trim();
    const parts = email.split('@');
    if (parts.length !== 2 || !parts[0] || !/[^\x00-\x7f]/.test(parts[1])) return value;
    const domain = parts[1];
    // Never interpret URL syntax as part of an email domain.
    if (/[\s\\/:?#%\[\]]/.test(domain)) return value;
    try {
      const hostname = new URL('https://' + domain).hostname;
      return parts[0] + '@' + hostname;
    } catch (_) {
      return value;
    }
  }
  function normalize(input) {
    if (!(input instanceof HTMLInputElement) || input.type !== 'email' || input.multiple) return;
    const value = normalizeEmailDomain(input.value);
    if (value !== input.value) input.value = value;
  }
  function normalizeForm(form) {
    if (form) for (const input of form.querySelectorAll('input[type="email"]')) normalize(input);
  }
  // Run before native constraint validation, including keyboard submission.
  document.addEventListener('change', event => normalize(event.target), true);
  document.addEventListener('focusout', event => normalize(event.target), true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter') normalizeForm(event.target.form);
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button, input[type="submit"], input[type="image"]');
    if (button && (button.type === 'submit' || button.type === 'image')) normalizeForm(button.form);
  }, true);
})();
